import { useState } from "react"
import { toast } from "react-toastify"
import { Button } from "../../../Components/Screen/Button/button"
import { Copy } from "phosphor-react"
import Barcode from "react-barcode"
import { saveGtin } from "../../../utils/firebase/nfts"
import { toEAN13 } from "../../../utils/barcode"

export const InfosNFTComponent = ({ nft, token_id, hash, nftDb, gtin }) => {
    const url = process.env.REACT_APP_LOCAL_ENV === 'dev' ? `https://amoy.polygonscan.com/tx/${hash?.transaction_hash}` : `https://polygonscan.com/tx/${hash?.transaction_hash}`
    const [gtinInput, setGtinInput] = useState(nftDb?.gtin || gtin || "")
    const [saving, setSaving] = useState(false)
    const [showPasswordModal, setShowPasswordModal] = useState(false)
    const [password, setPassword] = useState("")
    const [unlocked, setUnlocked] = useState(false)

    function copyToClipboard(text) {
        navigator.clipboard.writeText(text)
        toast('Hash copiado para a área de transferência', { type: 'success' })
    }

    function handleBarcodeClick() {
        if (unlocked) return
        setShowPasswordModal(true)
    }

    function handlePasswordSubmit() {
        if (password === "vinhosdobrasil") {
            setUnlocked(true)
            setShowPasswordModal(false)
            setPassword("")
        } else {
            toast('Senha incorreta', { type: 'error' })
            setPassword("")
        }
    }

    async function handleSaveGtin() {
        if (!gtinInput.trim()) return
        setSaving(true)
        try {
            await saveGtin(token_id, gtinInput.trim())
            toast('GTIN salvo com sucesso', { type: 'success' })
        } catch {
            toast('Erro ao salvar GTIN', { type: 'error' })
        } finally {
            setSaving(false)
        }
    }

    return (
        <>
            {showPasswordModal && (
                <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50" onClick={() => setShowPasswordModal(false)}>
                    <div className="bg-zinc-900 border border-white/20 rounded-xl p-6 flex flex-col gap-4 w-72" onClick={(e) => e.stopPropagation()}>
                        <h2 className="text-white text-lg font-bold">Senha</h2>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handlePasswordSubmit()}
                            placeholder="Digite a senha"
                            autoFocus
                            className="bg-transparent border border-white/30 rounded px-3 py-2 text-white text-sm focus:outline-none focus:border-white"
                        />
                        <div className="flex gap-2 justify-end">
                            <button onClick={() => { setShowPasswordModal(false); setPassword("") }} className="text-white/50 text-sm px-3 py-1">Cancelar</button>
                            <button onClick={handlePasswordSubmit} className="bg-white text-black text-sm px-4 py-1 rounded">Entrar</button>
                        </div>
                    </div>
                </div>
            )}

            <ul>
                <h1 className="text-white text-2xl font-bold">{nft?.name} - id: {token_id}</h1>
                {nft?.attributes?.map((attribute) => (
                    <li className="text-sm text-white" key={attribute?.trait_type}>
                        {attribute?.trait_type}: {attribute?.value}
                    </li>
                ))}
                <li className="text-sm text-white mb-2 md:hidden flex gap-2 items-center">
                    Blockchain hash: {hash?.transaction_hash?.slice(0, 10)}...{hash?.transaction_hash?.slice(-10)} <Copy size={28} onClick={() => copyToClipboard(hash?.transaction_hash)} />
                </li>
                <li className="text-sm text-white mb-2 hidden md:flex gap-2 items-center">
                    Blockchain hash: {hash?.transaction_hash} <Copy size={28} onClick={() => copyToClipboard(hash?.transaction_hash)} />
                </li>

                {unlocked && (
                    <li className="text-sm text-white mt-4 flex flex-col gap-2">
                        <span>GTIN</span>
                        <div className="flex gap-2 items-center">
                            <input
                                type="text"
                                value={gtinInput}
                                onChange={(e) => setGtinInput(e.target.value)}
                                placeholder="Digite o GTIN"
                                className="bg-transparent border border-white/30 rounded px-3 py-1 text-white text-sm focus:outline-none focus:border-white w-48"
                            />
                            <button
                                onClick={handleSaveGtin}
                                disabled={saving}
                                className="bg-white text-black text-sm px-3 py-1 rounded disabled:opacity-50"
                            >
                                {saving ? 'Salvando...' : 'Salvar'}
                            </button>
                        </div>
                    </li>
                )}

                <li className="text-sm text-white mt-4 flex flex-col items-center gap-1 cursor-pointer" onClick={handleBarcodeClick}>
                    <span>Código de barras</span>
                    {toEAN13(gtinInput).length === 13 ? (
                        <Barcode
                            value={toEAN13(gtinInput)}
                            format="EAN13"
                            background="#ffffff"
                            lineColor="#000000"
                            width={1.5}
                            height={60}
                            fontSize={12}
                        />
                    ) : (
                        <span className="text-white/40 text-xs mt-1">Nenhum GTIN cadastrado</span>
                    )}
                </li>
            </ul>
            <a
                href={url}
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center"
                title="Clique para acessar a transação no PolygonScan"
            >
                <Button>
                    Acessar transação
                </Button>
            </a>
        </>
    )
}